import { Brand } from '../enums/brand.enum';
import { Role } from '../enums/role.enum';

interface IBrandRole {
  fullName: string;
  shortName: string;
  isEnabled: boolean;
}

interface IRole {
  [Brand.RCCL]: IBrandRole;
  [Brand.CELEBRITY]: IBrandRole;
  [Brand.AZAMARA]: IBrandRole;
}

export const ROLE_DATA: {
  [key: string]: IRole;
} = {
  [Role.Admin]: {
    [Brand.RCCL]: {
      fullName: 'Admin',
      shortName: 'Admin',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'Admin',
      shortName: 'Admin',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'Admin',
      shortName: 'Admin',
      isEnabled: true,
    },
  },

  [Role.CrewAdminManager]: {
    [Brand.RCCL]: {
      fullName: 'CRMG',
      shortName: 'CRMG',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'Crew Administrator',
      shortName: 'CFAD',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'Invalid',
      shortName: 'Invalid',
      isEnabled: false,
    },
  },

  [Role.Finance]: {
    [Brand.RCCL]: {
      fullName: 'Finance',
      shortName: 'Finance',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'Finance',
      shortName: 'Finance',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'Finance',
      shortName: 'Finance',
      isEnabled: true,
    },
  },

  [Role.HRManager]: {
    [Brand.RCCL]: {
      fullName: 'HR Manager',
      shortName: 'HR Manager',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'HR Manager',
      shortName: 'HR Manager',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'HR Manager',
      shortName: 'HR Manager',
      isEnabled: true,
    },
  },

  [Role.HRTeam]: {
    [Brand.RCCL]: {
      fullName: 'HR Team',
      shortName: 'HR Team',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'HR Team',
      shortName: 'HR Team',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'HR Team',
      shortName: 'HR Team',
      isEnabled: true,
    },
  },

  [Role.Medical]: {
    [Brand.RCCL]: {
      fullName: 'Medical',
      shortName: 'Medical',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'Medical',
      shortName: 'Medical',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'Medical',
      shortName: 'Medical',
      isEnabled: true,
    },
  },

  [Role.Safety]: {
    [Brand.RCCL]: {
      fullName: 'STCW',
      shortName: 'STCW',
      isEnabled: true,
    },
    [Brand.CELEBRITY]: {
      fullName: 'STCW',
      shortName: 'STCW',
      isEnabled: true,
    },
    [Brand.AZAMARA]: {
      fullName: 'STCW',
      shortName: 'STCW',
      isEnabled: true,
    },
  },
};
